import { z } from "zod";

export const postAllergySchema = z.object({
  allergyName: z
    .string({ message: "Name is Required" })
    .min(1, { message: "Name is Required" })
    .max(100, { message: "Must be 100 or fewer characters long" }),
  allergyDescription: z.string({ message: "Description is Required" }),
  allergyLevel: z.string({ message: "Allergy Level is Required" }),
  reactions: z.array(z.string()).nullish(),
  derivatives: z.array(z.string()).nullish(),
  isActive: z.number().int(),
});

export const putAllergySchema = z.object({
  allergyName: z
    .string({ message: "Name is Required" })
    .min(1, { message: "Name is Required" })
    .max(100, { message: "Must be 100 or fewer characters long" }),
  allergyDescription: z
    .string({ message: "Description is Required" })
    .min(1, { message: "Description is Required" }),
  allergyLevel: z
    .string({ message: "Allergy Level is Required" })
    .min(1, { message: "Allergy Level is Required" }),
  reactions: z.array(z.string()).nullish(),
  derivatives: z.array(z.string()).nullish(),
  isActive: z.optional(z.number().int()),
});
